// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"SliderResponsive_button-arrow__Olo26","button-arrow-icon":"SliderResponsive_button-arrow-icon__rAAQX"};